<template>
  <vue-tel-input
    v-model="internalPhoneNumber"
    :disabled="disabled"
    :class="addClass"
    v-on:country-changed="onCountryCodeChange"
    :inputOptions="inputOptions"
    :autoFormat="true"
    @validate="onValidate"
    :autoDefaultCountry="false"
    validCharactersOnly
    
  ></vue-tel-input>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
  props: [
    "disabled",
    "phoneNumber",
    "addClass",
    "onCountryCodeSelect",
    "onPhoneNumberChange",
    "placeholder",
    "validate"
  ],
  components: {
    VueTelInput,
  },
  data() {
    return {
      internalPhoneNumber: "",
      inputOptions: {
        placeholder: "",
        styleClasses:"v-phone-number-input"
      }
    };
  },
  methods: {
    onValidate(value) {
      if (this.validate) this.validate(value);

      if (this.onPhoneNumberChange) this.onPhoneNumberChange(value.number);
    },
    onCountryCodeChange(value) {
      if (this.onCountryCodeSelect) this.onCountryCodeSelect(value);
    },
  },
  created() {
    this.$watch("phoneNumber", (newPhoneNumber) => {
      this.internalPhoneNumber = newPhoneNumber;
    });
  },
  mounted() {
    this.inputOptions.placeholder = this.placeholder;
  },
};
</script>

<style>
.v-phone-number-input {
  color: #475f7b;
}
</style>